export enum TradeContractType {
    trade,
    auctionHouse,
    bid2Earn,
}